import { render, staticRenderFns } from "./MenuLocaleEditor.vue?vue&type=template&id=15f0c71e"
import script from "./MenuLocaleEditor.vue?vue&type=script&lang=ts"
export * from "./MenuLocaleEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports